/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Collapsed/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import DashboardAction from './DashboardAction/index'
import React from 'react'
import TasksBoardsList from 'DesignSystem/TasksBoardsList/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconExpand from 'DesignSystem/Svgs/TysiaIconExpand/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Collapsed({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Collapsed",
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let globalSidebarTogglesIsTasksSidebarOpenChangeData = fromData.useDataChange({ viewPath,
context: 'global',
path: 'sidebar_toggles.is_tasks_sidebar_open',
formatOut: fromHelpers.not,
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="Collapsed.Vertical"
  data-view-path={viewPath}
 style={{'--brc-1-ZtETHC': dtColorsNeutral200,'--bc-2-ZtETHC': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="Collapsed.Vertical:1"
  data-view-path={viewPath}
 onClick={globalSidebarTogglesIsTasksSidebarOpenChangeData}
 {...isHoveredBind}
 style={{'--bbc-3-ZtETHC': dtColorsNeutral200,'--bc-2-ZtETHC': dtColorsNeutral100,'--pb-4-ZtETHC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-5-ZtETHC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaIconExpand
  viewPath={`${viewPath}/TysiaIconExpand`}
/>
</button>
<div
  data-testid="Collapsed.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<DashboardAction
  viewPath={`${viewPath}/DashboardAction`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 width={36}
 marginRight="auto"
 marginLeft="auto"
 theme="light"
/>
<TasksBoardsList
  viewPath={`${viewPath}/TasksBoardsList`}
 type="private"
 collapse={false}
 iconOnly={true}
 showPrivateIcon={true}
/>
<TasksBoardsList
  viewPath={`${viewPath}/TasksBoardsList`}
 type="my-boards"
 collapse={false}
 iconOnly={true}
/>
</div>
</div>
{children}
</React.Fragment>)
}